
export const stripPageNumber = (pageURL: string) => {
    if(pageURL.includes('/page')) {
        return pageURL = pageURL.substring(0, pageURL.indexOf('/page'));
    }

    return pageURL;
};